import HttpService from "../../constant/Api";

const API = "v2/inbox/user";
const ReadAPI = "v1/admin/notifications/read-all";

export const getMessageListService = (
  params = {
    pageNumber: 0,
    pageSize: 999,
    sort: "DESC",
    sortKey: "id",
  }
) => {
  return HttpService.get(API, { params });
};

export const postReadMessageService = () => {
  return HttpService.post(ReadAPI);
};
